module.exports = __webpack_public_path__ + "img/logo-amazon.fea38bbf.svg";